import React from "react";
import { Card, Typography, withStyles, Grid } from "@material-ui/core";
import { CircularProgressbar, buildStyles } from "react-circular-progressbar";
import "react-circular-progressbar/dist/styles.css";
import { BrandColors } from "../../../styles/BrandColors";
import styles from "./styles";
import { useTranslation } from "react-i18next";

const TwoValuePieCard = (props) => {
  const { classes, totalLabel, valueColor, value1, value2, hideChart } = props;
  const { t } = useTranslation();
  const total = value1 + value2;
  const percentage = total > 0 ? Math.round((value1 / total) * 100) : 0;
  return (
    <Card className={classes.cardContainer} variant="outlined" elevation={0}>
      <Grid container spacing={2} justify="center" alignItems="center">
        <Grid item>
          {!isNaN(total) && <Grid container direction="column" alignItems="center">
            <Grid item>
              <Typography
                variant="h2"
                component="h2"
                style={{
                  color: valueColor ? valueColor : BrandColors.JLLBrandColors.Black.tint50Percent
                }}
              >
                {total}
              </Typography>
            </Grid>
            <Grid item>
              <Typography>{totalLabel}</Typography>
            </Grid>
          </Grid>}
        </Grid>
        {!isNaN(total) && total > 0 && hideChart !== true && (
          <Grid item xs={4}>
            <CircularProgressbar
              strokeWidth={10}
              value={percentage}
              text={`${percentage}% ${t('AML')}`}
              styles={buildStyles({
                pathColor: "#E30613",
                textColor: "grey",
                textSize: "18px",
                trailColor: "grey",
                strokeLinecap: "butt",
                pathTransitionDuration: 1,
              })}
            />
          </Grid>
        )}
      </Grid>
    </Card>
  );
};

export default withStyles(styles, { withTheme: true })(TwoValuePieCard);
